import { lazy } from "react";
import { type RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import CustomerManagement from "../pages/dashboard/by-vendor/wedding-planner/customers/page";
import ConsultationSchedule from "../pages/dashboard/by-vendor/wedding-planner/consultation/page";
import CustomerSchedule from "../pages/dashboard/by-vendor/wedding-planner/schedule/page";
import SettlementManagement from "../pages/dashboard/by-vendor/wedding-planner/settlement/page";
import OrderManagement from "../pages/dashboard/by-vendor/wedding-planner/orders/page";
import ReservationManagement from "../pages/dashboard/by-vendor/wedding-planner/reservations/page";
import InventoryManagement from "../pages/dashboard/by-vendor/dress/inventory/page";
import UserPermissions from "../pages/dashboard/by-vendor/wedding-planner/permissions/page";
import CustomerDetail from "../pages/dashboard/by-vendor/wedding-planner/customer-detail/page";
import CustomerDetailView from "../pages/dashboard/by-vendor/wedding-planner/customer-detail-view/page";
import VendorInvite from "../pages/dashboard/by-vendor/wedding-planner/vendor-invite/page";
import VendorPortal from "../pages/dashboard/vendor-portal/page";
import VendorManagement from "../pages/dashboard/by-vendor/wedding-planner/vendors/page";
import VendorDetail from "../pages/dashboard/by-vendor/wedding-planner/vendor-detail/page";
import MenuManagement from "../pages/dashboard/by-vendor/wedding-planner/menu-management/page";
import StudioSchedule from "../pages/dashboard/by-vendor/studio/studio-schedule/page";
import StudioCustomers from "../pages/dashboard/by-vendor/studio/studio-customers/page";
import StudioCustomerDetail from "../pages/dashboard/by-vendor/studio/studio-customer-detail/page";
import StudioStaff from "../pages/dashboard/by-vendor/studio/studio-staff/page";
import StudioRequests from "../pages/dashboard/by-vendor/studio/studio-requests/page";
import StudioPhotos from "../pages/dashboard/by-vendor/studio/studio-photos/page";
import MakeupSchedule from "../pages/dashboard/by-vendor/makeup/makeup-schedule/page";
import MakeupArtists from "../pages/dashboard/by-vendor/makeup/makeup-artists/page";
import MakeupCustomers from "../pages/dashboard/by-vendor/makeup/makeup-customers/page";
import MakeupChecklist from "../pages/dashboard/by-vendor/makeup/makeup-checklist/page";
import MakeupGallery from "../pages/dashboard/by-vendor/makeup/makeup-gallery/page";
import MakeupPayments from "../pages/dashboard/by-vendor/makeup/makeup-payments/page";
import ConsultationRooms from "../pages/dashboard/by-vendor/wedding-planner/consultation-rooms/page";
import DressingRooms from "../pages/dashboard/by-vendor/dress/dressing-rooms/page";

// Dress Shop Pages
import DressShopCustomers from "../pages/dashboard/by-vendor/dress-shop/customers/page";
import DressShopCustomerDetail from "../pages/dashboard/by-vendor/dress-shop/customer-detail/page";
import DressShopProducts from "../pages/dashboard/by-vendor/dress-shop/products/page";
import DressShopContracts from "../pages/dashboard/by-vendor/dress-shop/contracts/page";
import DressShopContractDetail from "../pages/dashboard/by-vendor/dress-shop/contract-detail/page";
import DressShopSchedules from "../pages/dashboard/by-vendor/dress-shop/schedules/page";
import DressShopWorkOrders from "../pages/dashboard/by-vendor/dress-shop/work-orders/page";
import DressShopPayments from "../pages/dashboard/by-vendor/dress-shop/payments/page";
import DressShopDashboard from "../pages/dashboard/by-vendor/dress-shop/dashboard/page";
import DressShopDressingRooms from "../pages/dashboard/by-vendor/dress-shop/dressing-rooms/page";
import DressShopPermissions from "../pages/dashboard/by-vendor/dress-shop/permissions/page";
import DressShopMyVendor from "../pages/dashboard/by-vendor/dress-shop/my-vendor/page";

// Suit Shop Pages
import SuitCustomers from "../pages/dashboard/by-vendor/suit-shop/customers/page";
import SuitCustomerDetail from "../pages/dashboard/by-vendor/suit-shop/customer-detail/page";
import SuitContracts from "../pages/dashboard/by-vendor/suit-shop/contracts/page";
import SuitContractDetail from "../pages/dashboard/by-vendor/suit-shop/contract-detail/page";
import SuitSchedules from "../pages/dashboard/by-vendor/suit-shop/schedules/page";
import SuitWorkOrders from "../pages/dashboard/by-vendor/suit-shop/work-orders/page";
import SuitProducts from "../pages/dashboard/by-vendor/suit-shop/products/page";
import SuitPayments from "../pages/dashboard/by-vendor/suit-shop/payments/page";
import SuitDashboard from "../pages/dashboard/by-vendor/suit-shop/dashboard/page";
import SuitFittingRooms from "../pages/dashboard/by-vendor/suit-shop/fitting-rooms/page";
import SuitPermissions from "../pages/dashboard/by-vendor/suit-shop/permissions/page";
import SuitMyVendor from "../pages/dashboard/by-vendor/suit-shop/my-vendor/page";
// Photo Studio Pages
import PhotoStudioCustomers from "../pages/dashboard/by-vendor/photo-studio/customers/page";
import PhotoStudioCustomerDetail from "../pages/dashboard/by-vendor/photo-studio/customer-detail/page";
import PhotoStudioProducts from "../pages/dashboard/by-vendor/photo-studio/products/page";
import PhotoStudioContracts from "../pages/dashboard/by-vendor/photo-studio/contracts/page";
import PhotoStudioContractDetail from "../pages/dashboard/by-vendor/photo-studio/contract-detail/page";
import PhotoStudioSchedules from "../pages/dashboard/by-vendor/photo-studio/schedules/page";
import PhotoStudioWorkOrders from "../pages/dashboard/by-vendor/photo-studio/work-orders/page";
import PhotoStudioPayments from "../pages/dashboard/by-vendor/photo-studio/payments/page";
import PhotoStudioDashboard from "../pages/dashboard/by-vendor/photo-studio/dashboard/page";
import PhotoStudioSelectRooms from "../pages/dashboard/by-vendor/photo-studio/select-rooms/page";
import PhotoStudioPermissions from "../pages/dashboard/by-vendor/photo-studio/permissions/page";
import PhotoStudioMyVendor from "../pages/dashboard/by-vendor/photo-studio/my-vendor/page";

// Makeup Shop Pages
import MakeupShopCustomers from "../pages/dashboard/by-vendor/makeup-shop/customers/page";
import MakeupShopCustomerDetail from "../pages/dashboard/by-vendor/makeup-shop/customer-detail/page";
import MakeupShopSchedules from "../pages/dashboard/by-vendor/makeup-shop/schedules/page";
import MakeupShopSettlements from "../pages/dashboard/by-vendor/makeup-shop/settlements/page";
import MakeupShopDashboard from "../pages/dashboard/by-vendor/makeup-shop/dashboard/page";
import MakeupShopPermissions from "../pages/dashboard/by-vendor/makeup-shop/permissions/page";
import MakeupShopMyVendor from "../pages/dashboard/by-vendor/makeup-shop/my-vendor/page";
import MakeupShopArtistGrid from "../pages/dashboard/by-vendor/makeup-shop/artist-grid/page";
import MakeupShopInventory from "../pages/dashboard/by-vendor/makeup-shop/inventory/page";

// Wedding Hall Pages
import WeddingHallCustomers from "../pages/dashboard/by-vendor/wedding-hall/customers/page";
import WeddingHallCustomerDetail from "../pages/dashboard/by-vendor/wedding-hall/customer-detail/page";
import WeddingHallSchedules from "../pages/dashboard/by-vendor/wedding-hall/schedules/page";
import WeddingHallSettlements from "../pages/dashboard/by-vendor/wedding-hall/settlements/page";
import WeddingHallVenues from "../pages/dashboard/by-vendor/wedding-hall/venues/page";
import WeddingHallDashboard from "../pages/dashboard/by-vendor/wedding-hall/dashboard/page";
import WeddingHallPermissions from "../pages/dashboard/by-vendor/wedding-hall/permissions/page";
import WeddingHallMyVendor from "../pages/dashboard/by-vendor/wedding-hall/my-vendor/page";
import WeddingHallVenueGrid from "../pages/dashboard/by-vendor/wedding-hall/venue-grid/page";
import WeddingHallDayManagement from "../pages/dashboard/by-vendor/wedding-hall/day-management/page";

// Vendor Portal Pages
import VendorOrders from "../pages/vendor-portal/orders/page";
import VendorStudioSchedule from "../pages/vendor-portal/studio-schedule/page";
import VendorStudioCustomers from "../pages/vendor-portal/studio-customers/page";
import VendorStudioStaff from "../pages/vendor-portal/studio-staff/page";
import VendorStudioPhotos from "../pages/vendor-portal/studio-photos/page";
import VendorStudioRequests from "../pages/vendor-portal/studio-requests/page";
import MyVendorPage from "../pages/dashboard/by-vendor/guest/my-vendor/page";
import GuestOrderPage from "../pages/dashboard/by-vendor/guest/guest-order/page";
import RequireAuth from "../components/auth/reauireAuth";

const HomePage = lazy(() => import('../pages/home/page'));
const LoginPage = lazy(() => import('../pages/login/page'));
const MasterLoginPage = lazy(() => import('../pages/master/login/page'));
const MasterDashboardPage = lazy(() => import('../pages/master/dashboard/page'));
const MasterMenuCategoriesPage = lazy(() => import('../pages/master/menu-categories/page'));
const MasterVendorRegisterPage = lazy(() => import('../pages/master/vendor-register/page'));
const ChangePasswordPage = lazy(() => import('../pages/change-password/page'));
const DashboardPage = lazy(() => import('../pages/dashboard/by-vendor/wedding-planner/page'));
const DressListPage = lazy(() => import('../pages/dashboard/by-vendor/dress/dress-list/page'));
const DressDetailPage = lazy(() => import('../pages/dashboard/by-vendor/dress/dress-detail/page'));
const InventoryCalendarPage = lazy(() => import('../pages/dashboard/by-vendor/dress/inventory-calendar/page'));
const ContractDetailPage = lazy(() => import('../pages/dashboard/by-vendor/dress/contract-detail/page'));
const MaintenancePage = lazy(() => import('../pages/dashboard/by-vendor/dress/maintenance/page'));
const routes: RouteObject[] = [
  // 1. 누구나 접근 가능한 페이지 (Public)
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/login',
    element: <LoginPage />,
  },
  {
    path: '/master/login',
    element: <MasterLoginPage />,
  },
  
  // 2. 로그인이 필요한 페이지들 (Protected)
  {
    element: <RequireAuth />, // 여기서 인증 체크를 합니다.
    children: [
      // 대시보드 및 내부 페이지들 (이제 모두 보호됩니다)
      { path: "/dashboard", element: <DashboardPage /> }, // or <Dashboard /> 중복 제거 필요
      { path: "/change-password", element: <ChangePasswordPage /> },
      { path: "/dashboard/customers", element: <CustomerManagement /> },
      { path: "/dashboard/customer-detail", element: <CustomerDetail /> },
      { path: "/dashboard/customer-detail-view", element: <CustomerDetailView /> },
      { path: "/dashboard/consultation", element: <ConsultationSchedule /> },
      { path: "/dashboard/consultation-rooms", element: <ConsultationRooms /> },
      { path: "/dashboard/schedule", element: <CustomerSchedule /> },
      { path: "/dashboard/settlement", element: <SettlementManagement /> },
      { path: "/dashboard/orders", element: <OrderManagement /> },
      { path: "/dashboard/reservations", element: <ReservationManagement /> },
      { path: "/dashboard/inventory", element: <InventoryManagement /> },
      { path: "/dashboard/permissions", element: <UserPermissions /> },
      { path: "/dashboard/menu-management", element: <MenuManagement /> },
      { path: "/dashboard/vendors", element: <VendorManagement /> },
      { path: "/dashboard/vendor-detail", element: <VendorDetail /> },
      { path: "/dashboard/vendor-invite", element: <VendorInvite /> },
      { path: "/dashboard/dress-list", element: <DressListPage /> },
      { path: "/dashboard/dress-detail/:id", element: <DressDetailPage /> },
      { path: "/dashboard/inventory-calendar", element: <InventoryCalendarPage /> },
      { path: "/dashboard/dressing-rooms", element: <DressingRooms /> },
      { path: "/dashboard/contract-detail/:id", element: <ContractDetailPage /> },
      { path: "/dashboard/maintenance", element: <MaintenancePage /> },
      { path: "/dashboard/studio-schedule", element: <StudioSchedule /> },
      { path: "/dashboard/studio-customers", element: <StudioCustomers /> },
      { path: "/dashboard/studio-customer-detail", element: <StudioCustomerDetail /> },
      { path: "/dashboard/studio-staff", element: <StudioStaff /> },
      { path: "/dashboard/studio-requests", element: <StudioRequests /> },
      { path: "/dashboard/studio-photos", element: <StudioPhotos /> },
      { path: "/dashboard/makeup-schedule", element: <MakeupSchedule /> },
      { path: "/dashboard/makeup-artists", element: <MakeupArtists /> },
      { path: "/dashboard/makeup-customers", element: <MakeupCustomers /> },
      { path: "/dashboard/makeup-checklist", element: <MakeupChecklist /> },
      { path: "/dashboard/makeup-gallery", element: <MakeupGallery /> },
      { path: "/dashboard/makeup-payments", element: <MakeupPayments /> },
      { path: "/dashboard/my-vendor", element: <MyVendorPage /> },
      { path: "/dashboard/guest-orders", element: <GuestOrderPage /> },

      // 드레스샵 (Dress Shop)
      { path: "/dress-shop/customers", element: <DressShopCustomers /> },
      { path: "/dress-shop/customer-detail", element: <DressShopCustomerDetail /> },
      { path: "/dress-shop/products", element: <DressShopProducts /> },
      { path: "/dress-shop/contracts", element: <DressShopContracts /> },
      { path: "/dress-shop/contract-detail", element: <DressShopContractDetail /> },
      { path: "/dress-shop/schedules", element: <DressShopSchedules /> },
      { path: "/dress-shop/work-orders", element: <DressShopWorkOrders /> },
      { path: "/dress-shop/payments", element: <DressShopPayments /> },
      { path: "/dress-shop/dashboard", element: <DressShopDashboard /> },
      { path: "/dress-shop/dressing-rooms", element: <DressShopDressingRooms /> },
      { path: "/dress-shop/permissions", element: <DressShopPermissions /> },
      { path: "/dress-shop/my-vendor", element: <DressShopMyVendor /> },

      // 예복샵 (Suit Shop)
      { path: "/suit-shop/customers", element: <SuitCustomers /> },
      { path: "/suit-shop/customer-detail", element: <SuitCustomerDetail /> },
      { path: "/suit-shop/products", element: <SuitProducts /> },
      { path: "/suit-shop/contracts", element: <SuitContracts /> },
      { path: "/suit-shop/contract-detail", element: <SuitContractDetail /> },
      { path: "/suit-shop/schedules", element: <SuitSchedules /> },
      { path: "/suit-shop/work-orders", element: <SuitWorkOrders /> },
      { path: "/suit-shop/payments", element: <SuitPayments /> },
      { path: "/suit-shop/dashboard", element: <SuitDashboard /> },
      { path: "/suit-shop/fitting-rooms", element: <SuitFittingRooms /> },
      { path: "/suit-shop/permissions", element: <SuitPermissions /> },
      { path: "/suit-shop/my-vendor", element: <SuitMyVendor /> },

      // 포토스튜디오 (Photo Studio)
      { path: "/photo-studio/customers", element: <PhotoStudioCustomers /> },
      { path: "/photo-studio/customer-detail", element: <PhotoStudioCustomerDetail /> },
      { path: "/photo-studio/products", element: <PhotoStudioProducts /> },
      { path: "/photo-studio/contracts", element: <PhotoStudioContracts /> },
      { path: "/photo-studio/contract-detail", element: <PhotoStudioContractDetail /> },
      { path: "/photo-studio/schedules", element: <PhotoStudioSchedules /> },
      { path: "/photo-studio/schedules/consultation", element: <PhotoStudioSchedules /> },
      { path: "/photo-studio/schedules/shooting", element: <PhotoStudioSchedules /> },
      { path: "/photo-studio/schedules/select", element: <PhotoStudioSchedules /> },
      { path: "/photo-studio/work-orders", element: <PhotoStudioWorkOrders /> },
      { path: "/photo-studio/payments", element: <PhotoStudioPayments /> },
      { path: "/photo-studio/dashboard", element: <PhotoStudioDashboard /> },
      { path: "/photo-studio/select-rooms", element: <PhotoStudioSelectRooms /> },
      { path: "/photo-studio/permissions", element: <PhotoStudioPermissions /> },
      { path: "/photo-studio/my-vendor", element: <PhotoStudioMyVendor /> },

      // 메이크업샵 (Makeup Shop)
      { path: "/makeup-shop/customers", element: <MakeupShopCustomers /> },
      { path: "/makeup-shop/customer-detail", element: <MakeupShopCustomerDetail /> },
      { path: "/makeup-shop/schedules", element: <MakeupShopSchedules /> },
      { path: "/makeup-shop/settlements", element: <MakeupShopSettlements /> },
      { path: "/makeup-shop/dashboard", element: <MakeupShopDashboard /> },
      { path: "/makeup-shop/permissions", element: <MakeupShopPermissions /> },
      { path: "/makeup-shop/my-vendor", element: <MakeupShopMyVendor /> },
      { path: "/makeup-shop/artist-grid", element: <MakeupShopArtistGrid /> },
      { path: "/makeup-shop/inventory", element: <MakeupShopInventory /> },

      // 웨딩홀 (Wedding Hall)
      { path: "/wedding-hall/customers", element: <WeddingHallCustomers /> },
      { path: "/wedding-hall/customer-detail", element: <WeddingHallCustomerDetail /> },
      { path: "/wedding-hall/schedules", element: <WeddingHallSchedules /> },
      { path: "/wedding-hall/settlements", element: <WeddingHallSettlements /> },
      { path: "/wedding-hall/venues", element: <WeddingHallVenues /> },
      { path: "/wedding-hall/dashboard", element: <WeddingHallDashboard /> },
      { path: "/wedding-hall/permissions", element: <WeddingHallPermissions /> },
      { path: "/wedding-hall/my-vendor", element: <WeddingHallMyVendor /> },
      { path: "/wedding-hall/venue-grid", element: <WeddingHallVenueGrid /> },
      { path: "/wedding-hall/day-management", element: <WeddingHallDayManagement /> },

      { path: "/master", element: <MasterDashboardPage /> },
      { path: "/master/menu-categories", element: <MasterMenuCategoriesPage /> },
      { path: "/master/vendors/new", element: <MasterVendorRegisterPage /> },

      // 벤더 포털도 로그인이 필요하다면 여기에 포함
      { path: "/vendor-portal", element: <VendorPortal /> },
      { path: "/vendor-portal/orders", element: <VendorOrders /> },
      { path: "/vendor-portal/studio-schedule", element: <VendorStudioSchedule /> },
      { path: "/vendor-portal/studio-customers", element: <VendorStudioCustomers /> },
      { path: "/vendor-portal/studio-staff", element: <VendorStudioStaff /> },
      { path: "/vendor-portal/studio-photos", element: <VendorStudioPhotos /> },
      { path: "/vendor-portal/studio-requests", element: <VendorStudioRequests /> },
    ]
  },

  // 3. 404 페이지
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
